module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ipoint-success"
  }, [_c('message', {
    attrs: {
      "type": "success",
      "msg": "我怎么知道呢"
    }
  }), _vm._v(" "), _vm._m(0, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ipoint-success-content"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/success.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Ipoint successful transfer to your friends")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26da1c06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/iPointTransfer.vue
// module id = 795
// module chunks = 0